import React, {memo}  from 'react'
import AuthenticationContext from 'shared/components/AuthenticationContext'
import Button from 'components/shared/Button'
import CurrentUser from './CurrentUser'

import config from 'lib/config'

const aud = 'meglerapp'

const LogoutButton = (props) => {
  const logOut = (signout, jwt) => {
    fetch(`${config.GRAPHQL_URL}/auth/jwt`, {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        token: jwt,
        aud,
      })
    }).then(() => {
      signout()
      window.location.reload(true)
    })

    // In case the request to logout takes a while, we redirect the user after
    // a certain point anyway.
    setTimeout(() => window.location.reload(true), 1200)
  }

  return (
    <AuthenticationContext.Consumer>
      {({signOut, jwt}) => (
        <>
          {signOut && (
            <CurrentUser>
              {({broker}) => (
                <Button
                  secondary
                  type="action"
                  onClick={logOut.bind(null, signOut, jwt)}
                  {...props}
                >
                  Logg ut ({broker.email})
                </Button>
              )}
            </CurrentUser>
          )}
        </>
      )}
    </AuthenticationContext.Consumer>
  )
}

export default memo(LogoutButton)
